import { render, staticRenderFns } from "./ReplacementList.vue?vue&type=template&id=1c07ac24&scoped=true"
import script from "./ReplacementList.vue?vue&type=script&lang=js"
export * from "./ReplacementList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c07ac24",
  null
  
)

export default component.exports